<template>
  <div class="animated fadeIn dda-category-list">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Quản lý loại mẫu</h4>
          </div>
          <div class="text-right">
            <el-button round class="btn-default" type="info" @click="toggleSearch">Ẩn/hiện tìm kiếm</el-button>
            <el-button round class="btn-default" @click="openCreateDialog">Thêm mới</el-button>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-search">
            <b-collapse :visible="mData.tableRules.showFormSearch" id="ddaCategorySearch" class="mb-3">
              <el-card>
                <el-form
                  ref="searchForm"
                  label-position="top"
                  @submit.native.prevent
                  :model="mData.tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Mã loại mẫu">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.code"
                          clearable
                          @change="normalizeSearchCode"
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tên loại mẫu">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value.name"
                          clearable
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Trạng thái khóa">
                        <el-select v-model="mData.tableRules.dataSearch.value.disabled" clearable>
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiKhoa"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button round class="btn-default" native-type="submit" @click="searchTable">Tìm kiếm</el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>

          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              @sort-change="sortTable"
              :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }"
            >
              <el-table-column label="STT" width="60" align="center">
                <template slot-scope="scope">
                  {{ mData.tableRules.offset + scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="code" label="Mã loại mẫu" min-width="180" sortable="custom" />
              <el-table-column prop="name" label="Tên loại mẫu" min-width="240" sortable="custom" />
              <el-table-column label="Khóa" width="70" align="center">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.disabled" @change="toggleDisabled(scope.row)" />
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    round
                    type="primary"
                    @click="openUpdateDialog(scope.row.id)"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    round
                    type="danger"
                    @click="remove(scope.row.id)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-8 offset-md-4 text-right">
                <el-pagination
                  @size-change="onSizeChange"
                  @current-change="onCurrentChange"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                />
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="mData.viewMode === 'create' ? 'Thêm mới loại mẫu' : 'Cập nhật loại mẫu'"
      :visible.sync="formDialog"
      width="640px"
      :before-close="resetForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        v-if="formDialog"
        ref="formDialog"
        :model="mData.dataForm"
        :rules="mData.validForm"
        label-position="top"
        @submit.native.prevent
      >
        <b-row>
          <b-col md="6">
            <el-form-item label="Mã loại mẫu" prop="code">
              <el-input v-model.trim="mData.dataForm.code" @change="normalizeFormCode" />
            </el-form-item>
          </b-col>
          <b-col md="6">
            <el-form-item label="Tên loại mẫu" prop="name">
              <el-input v-model="mData.dataForm.name" />
            </el-form-item>
          </b-col>
        </b-row>
        <div class="text-center mt-2">
          <el-button round class="btn-default" @click="submitForm">
            {{ mData.viewMode === 'create' ? 'Lưu' : 'Cập nhật' }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DataService from "@/service/DataService";
import LanguageService from "@/service/LanguageService";
import MethodService from "@/service/MethodService";
import DdaCategoryApi from "@/moduleApi/DdaCategoryApi";
import DdaCategoryListModel from "./DdaCategoryListModel";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      formDialog: false,
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "DocumentDrafting-category",
        dataForm: MethodService.copyObject(DdaCategoryListModel.dataForm),
        validForm: DdaCategoryListModel.validForm,
        tableRules: MethodService.copyObject(DdaCategoryListModel.tableRules),
        dataDefault: {
          listTrangThaiKhoa: DataService.listTrangThaiKhoa,
        },
      },
    };
  },
  methods: {
    async initTable() {
      const dataFilter = {
        filters: this.mData.tableRules.filters,
        limit: this.mData.tableRules.limit,
        offset: this.mData.tableRules.offset,
        sort: this.mData.tableRules.sort,
      };

      this.$router.replace({
        name: "Admin-DocumentDrafting-category-list",
        query: {
          ...dataFilter,
          page: this.mData.tableRules.page,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      }).catch(() => {});

      const res = await DdaCategoryApi.list(dataFilter);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.data = res.result || [];
    },
    normalizeSearchCode() {
      if (this.mData.tableRules.dataSearch.value.code) {
        this.mData.tableRules.dataSearch.value.code = this.mData.tableRules.dataSearch.value.code.trim().toUpperCase();
      }
    },
    normalizeFormCode() {
      if (this.mData.dataForm.code) {
        this.mData.dataForm.code = this.mData.dataForm.code.trim().toUpperCase();
      }
      if (this.mData.dataForm.name) {
        this.mData.dataForm.name = this.mData.dataForm.name.trim();
      }
    },
    searchTable() {
      if (this.mData.tableRules.dataSearch.value.name) {
        this.mData.tableRules.dataSearch.value.name = this.mData.tableRules.dataSearch.value.name.trim();
      }
      this.normalizeSearchCode();
      this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page = 1;
      this.initTable();
    },
    toggleSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-DocumentDrafting-category-list",
        query: {
          ...this.$route.query,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      }).catch(() => {});
    },
    sortTable(column) {
      if (column.order === "ascending") this.mData.tableRules.sort = column.prop;
      else if (column.order === "descending") this.mData.tableRules.sort = `-${column.prop}`;
      else this.mData.tableRules.sort = "";
      this.initTable();
    },
    onSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.mData.tableRules.page = 1;
      this.mData.tableRules.offset = 0;
      this.initTable();
    },
    onCurrentChange(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset = (page - 1) * this.mData.tableRules.limit;
      this.initTable();
    },
    openCreateDialog() {
      this.mData.viewMode = "create";
      this.formDialog = true;
    },
    async openUpdateDialog(id) {
      this.mData.viewMode = "update";
      this.mData.id = id;
      const res = await DdaCategoryApi.findById(id);
      if (res.result) {
        this.mData.dataForm = res.result;
        this.formDialog = true;
      }
    },
    async submitForm() {
      this.normalizeFormCode();
      this.$refs.formDialog.validate(async (valid) => {
        if (!valid) return;
        const data = MethodService.copyObject(this.mData.dataForm);
        try {
          if (this.mData.viewMode === "create") {
            await DdaCategoryApi.create(data);
          } else {
            data.id = this.mData.id;
            await DdaCategoryApi.update(data);
          }
          this.resetForm();
          await this.initTable();
        } catch (error) {
          window.toastr.error(error.message || (this.mData.viewMode === "create" ? "Thêm mới thất bại" : "Cập nhật thất bại"));
        }
      });
    },
    async toggleDisabled(row) {
      try {
        await DdaCategoryApi.update({ id: row.id, disabled: row.disabled });
      } catch (error) {
        row.disabled = !row.disabled;
        window.toastr.error(error.message || "Cập nhật trạng thái thất bại");
      }
    },
    remove(id) {
      this.$confirm(this.aLang.c_deleteConfirm, {
        confirmButtonText: this.aLang.c_agree,
        cancelButtonText: this.aLang.c_cancel,
        type: "warning",
      }).then(async () => {
        try {
          await DdaCategoryApi.delete(id);
          await this.initTable();
        } catch (error) {
          window.toastr.error(error.detail || error.message || "Xóa thất bại");
        }
      }).catch(() => {});
    },
    resetForm() {
      this.formDialog = false;
      this.mData.id = null;
      this.mData.viewMode = "create";
      this.mData.dataForm = MethodService.copyObject(DdaCategoryListModel.dataForm);
      if (this.$refs.formDialog) {
        this.$refs.formDialog.resetFields();
      }
    },
    syncFromRoute() {
      const query = this.$route.query;
      if (query.limit) this.mData.tableRules.limit = parseInt(query.limit);
      if (query.page) this.mData.tableRules.page = parseInt(query.page);
      this.mData.tableRules.offset = (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      if (query.sort) {
        this.mData.tableRules.sort = query.sort;
        this.mData.tableRules.defaultSort[0] = query.sort.replace("-", "");
        this.mData.tableRules.defaultSort[1] = query.sort.startsWith("-") ? "descending" : "ascending";
      }
      if (query.showFormSearch === "true") this.mData.tableRules.showFormSearch = true;
      if (query.showFormSearch === "false") this.mData.tableRules.showFormSearch = false;
      if (query.filters) {
        this.mData.tableRules.filters = query.filters;
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(query.filters);
        const nameMatch = query.filters.match(/\$vn_text=([^&]*)(&|$)/);
        const codeMatch = query.filters.match(/:regex_i:([^&]*)(&|$)/);
        if (nameMatch) this.$set(this.mData.tableRules.dataSearch.value, "name", decodeURIComponent(nameMatch[1]));
        if (codeMatch) this.$set(this.mData.tableRules.dataSearch.value, "code", decodeURIComponent(codeMatch[1]));
      }
    },
  },
  async created() {
    this.syncFromRoute();
    await this.initTable();
  },
};
</script>

<style lang="scss" scoped>
.dda-category-list {
  .main-card-body {
    padding: 20px 24px;
  }

  ::v-deep .el-table {
    thead tr th {
      background: var(--orange) !important;
    }
  }

  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background-color: #fff3eb;
  }

  ::v-deep .el-button {
    &.el-button--primary,
    &.el-button--info {
      color: #fff !important;
      background-color: var(--orange) !important;
      border-color: var(--orange) !important;

      &:hover,
      &:focus {
        color: #fff !important;
        background-color: #ffb482 !important;
        border-color: #ffb482 !important;
      }
    }
  }

  ::v-deep .el-pagination {
    .el-pager {
      .number:hover {
        color: var(--orange) !important;
      }

      .active {
        background-color: var(--orange) !important;
      }
    }
  }
}
</style>
